"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _dispatcher = _interopRequireDefault(require("dispatcher/dispatcher"));

var _AccountingExtensionsAPI = require("../api/AccountingExtensionsAPI");

var _ActionNamespaces = require("../../actions/ActionNamespaces");

var _LazyValueStore = require("crm_data/store/LazyValueStore");

var _default = (0, _LazyValueStore.defineLazyValueStore)({
  fetch: _AccountingExtensionsAPI.fetchExtensions,
  namespace: _ActionNamespaces.ACCOUNTING_EXTENSIONS
}).defineName('AccountingExtensionsStore').register(_dispatcher.default);

exports.default = _default;
module.exports = exports.default;